export enum STATES_ENUM {
  TRANSITION_CONTEXT_HYDRATION_PENDING = 'TRANSITION_CONTEXT_HYDRATION_PENDING',
  TRANSITION_INITIAL_STATE_RESOLVER = 'TRANSITION_INITIAL_STATE_RESOLVER',
  TRANSITION_ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS = 'TRANSITION_ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS',
  TRANSITION_ASYNC_SAVE_CUSTOMER_DATA = 'TRANSITION_ASYNC_SAVE_CUSTOMER_DATA',
  ADDRESS_SELECTOR = 'ADDRESS_SELECTOR',
  ELIGIBLE_SHIPPING_METHODS_SELECTOR = 'ELIGIBLE_SHIPPING_METHODS_SELECTOR',
  SHIPPING_METHOD_SELECTOR = 'SHIPPING_METHOD_SELECTOR',
  SHIPPING_METHOD_NOT_SELECTED = 'SHIPPING_METHOD_NOT_SELECTED',
  NEED_PICKUP_POINT_SELECTION = 'NEED_PICKUP_POINT_SELECTION',
  SUMMARY = 'SUMMARY',
  FETCH_SHIPPING_METHODS_ERROR = 'FETCH_SHIPPING_METHODS_ERROR',
}

export const TRANSITIONS_STATES = {
  [STATES_ENUM.TRANSITION_CONTEXT_HYDRATION_PENDING]:
    STATES_ENUM.TRANSITION_CONTEXT_HYDRATION_PENDING,
  [STATES_ENUM.TRANSITION_INITIAL_STATE_RESOLVER]:
    STATES_ENUM.TRANSITION_INITIAL_STATE_RESOLVER,

  [STATES_ENUM.TRANSITION_ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS]:
    STATES_ENUM.TRANSITION_ASYNC_FETCH_ELIGIBLE_SHIPPING_METHODS,

  [STATES_ENUM.TRANSITION_ASYNC_SAVE_CUSTOMER_DATA]:
    STATES_ENUM.TRANSITION_ASYNC_SAVE_CUSTOMER_DATA,
} as const;

export const UI_STATES = {
  [STATES_ENUM.ADDRESS_SELECTOR]: STATES_ENUM.ADDRESS_SELECTOR,

  [STATES_ENUM.ELIGIBLE_SHIPPING_METHODS_SELECTOR]:
    STATES_ENUM.ELIGIBLE_SHIPPING_METHODS_SELECTOR,

  [STATES_ENUM.SHIPPING_METHOD_SELECTOR]: STATES_ENUM.SHIPPING_METHOD_SELECTOR,

  [STATES_ENUM.SHIPPING_METHOD_NOT_SELECTED]:
    STATES_ENUM.SHIPPING_METHOD_NOT_SELECTED,

  [STATES_ENUM.NEED_PICKUP_POINT_SELECTION]:
    STATES_ENUM.NEED_PICKUP_POINT_SELECTION,

  [STATES_ENUM.SUMMARY]: STATES_ENUM.SUMMARY,

  [STATES_ENUM.FETCH_SHIPPING_METHODS_ERROR]:
    STATES_ENUM.FETCH_SHIPPING_METHODS_ERROR,
} as const;

export const STATES = {
  ...TRANSITIONS_STATES,
  ...UI_STATES,
} as const;
